<!--V3-->
<div class="card status-card m-4 shadow-sm" data-cy="status-card">
  <div class="card-container">
    <div class="row">
      <div class="col-lg-4 center-content title-col p-1" >
        <div class="row center-content">
          @if(icon){
            <div class="col center-content">
              <fa-icon class="status-card-title-icon" [icon]="icon"></fa-icon>
            </div>
          }
          <div class="col-auto center-content">
            <h4 data-cy="card-title">{{ title }}</h4>
            @if(description) {
              <p class="card-description" data-cy="card-description">{{description}}</p>
            }
          </div>
        </div>
      </div>
      <div class="col-lg-8 lights-col">
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 lights-col">
        <div class="row p-1">
          <div class="card-contents w-100">
            <form [formGroup]="antragstellerForm" id="antragstellerForm"
                  class="form-horizontal antragstellerForm m-0 p-0 g-0 w-100" accept-charset="UTF-8">
              <div class="row w-100">

                <div class="col-lg-4">

                  <div class="form-group sfk-form-vertical-spacer group-for-nachname mb-0 mt-0">
                    <app-custom-input id="nachname"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.NACHNAME'|translate)"
                                      [readonly] = true
                                      data-cy="as-nachname"
                    ></app-custom-input>
                  </div>

                  <div class="form-group sfk-form-vertical-spacer group-for-vorname mb-0 mt-0">
                    <app-custom-input id="vorname"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.VORNAME'|translate)"
                                      [readonly] = true
                                      data-cy="as-vorname"
                    ></app-custom-input>
                  </div>

                  <div class="form-group sfk-form-vertical-spacer group-for-geburtsdatum mb-0 mt-0">
                    <app-custom-input id="geburtsdatum"
                                      type="date"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.GEBURTSDATUM'|translate)"
                                      [readonly] = true
                                      data-cy="as-geburtsdatum"
                    ></app-custom-input>
                  </div>

                </div>

                <div class="col-lg-4">

                  <div class="form-group sfk-form-vertical-spacer group-for-email mb-0 mt-0">
                    <app-custom-input id="email"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.EMAIL'|translate)"
                                      [readonly] = true
                                      data-cy="as-email"
                    ></app-custom-input>
                  </div>

                  <div class="form-group sfk-form-vertical-spacer group-for-strasse mb-0 mt-0">
                    <app-custom-input id="strasse"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.STRASSE'|translate)"
                                      [readonly] = true
                                      data-cy="as-strasse"
                    ></app-custom-input>
                  </div>

                  <div class="form-group sfk-form-vertical-spacer group-for-adresszusatz mb-0 mt-0">
                    <app-custom-input id="adresszusatz"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.ADRESSZUSATZ'|translate)"
                                      [readonly] = true
                                      data-cy="as-adresszusatz"
                    ></app-custom-input>
                  </div>

                </div>

                <div class="col-lg-4">

                  <div class="form-group sfk-form-vertical-spacer group-for-plz mb-0 mt-0">
                    <app-custom-input id="plz"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.PLZ'|translate)"
                                      [readonly] = true
                                      data-cy="as-plz"
                    ></app-custom-input>
                  </div>

                  <div class="form-group sfk-form-vertical-spacer group-for-ort mb-0 mt-0">
                    <app-custom-input id="ort"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.ORT'|translate)"
                                      [readonly] = true
                                      data-cy="as-ort"
                    ></app-custom-input>
                  </div>

                  <div class="form-group sfk-form-vertical-spacer group-for-land mb-0 mt-0">
                    <app-custom-input id="land"
                                      type="text"
                                      [customFormGroup]="antragstellerForm"
                                      [label]="('STANDARD.LAND'|translate)"
                                      [readonly] = true
                                      data-cy="as-land"
                    ></app-custom-input>
                  </div>

                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
